import { render, staticRenderFns } from "./StepperItem.vue?vue&type=template&id=ace89a02&scoped=true"
import script from "./StepperItem.vue?vue&type=script&lang=js"
export * from "./StepperItem.vue?vue&type=script&lang=js"
import style0 from "./StepperItem.vue?vue&type=style&index=0&id=ace89a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace89a02",
  null
  
)

export default component.exports